// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Json_encode from "../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as Network$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TdsFormRepoConfig from "./TdsFormRepoConfig.bs.js";
import * as NetworkV2$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";

function fetchTdsFormData(uuid) {
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getHostName(undefined),
        tl: {
          hd: "/tds_requests/",
          tl: {
            hd: uuid,
            tl: /* [] */0
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TdsFormRepoConfig.TdsFormConverter.execute, result);
                            });
                }), requestUrl);
}

function submitTdsForm(data) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "pdf_type",
              data.pdfType
            ],
            tl: {
              hd: [
                "pdf_data",
                data.pdfData
              ],
              tl: {
                hd: [
                  "bucket_name",
                  data.bucketName
                ],
                tl: {
                  hd: [
                    "folder_name",
                    data.folderName
                  ],
                  tl: {
                    hd: [
                      "file_name",
                      data.fileName
                    ],
                    tl: {
                      hd: [
                        "callback_url",
                        data.callbackUrl
                      ],
                      tl: {
                        hd: [
                          "callback_params_json",
                          data.callbackParamsJson
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }));
  var requestUrl = Config.Env.getPdfGeneratorUrl(undefined);
  var headers = {
    "x-api-key": Config.Env.getPdfGeneratorLambdaKey(undefined)
  };
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: data
      });
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.post(requestUrl, Caml_option.some(headers), payloadString, undefined, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(TdsFormRepoConfig.TdsSubmissionConverter.execute, result);
                            });
                }), requestUrl);
}

var TdsRepo = {
  fetchTdsFormData: fetchTdsFormData,
  submitTdsForm: submitTdsForm
};

export {
  TdsRepo ,
  
}
/* Config Not a pure module */
